import { render } from "./TransactionList.vue?vue&type=template&id=4ced615e&scoped=true"
import script from "./TransactionList.vue?vue&type=script&lang=js"
export * from "./TransactionList.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4ced615e"

export default script